(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vd-brands"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-vd-brand-search]').forEach(input=>input.addEventListener('input',()=>{
  const root=input.closest('.vd-brands');const value=input.value.toLocaleLowerCase('tr-TR').trim();let count=0;
  root.querySelectorAll('[data-vd-brand]').forEach(item=>{item.hidden=!item.textContent.toLocaleLowerCase('tr-TR').includes(value);if(!item.hidden)count++;});
  root.querySelector('.vd-brands__empty').hidden=count>0;
}));

  } catch(e) { console.error(e); }
})();
})();
